/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {
    shape, object, string, arrayOf,
} from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

// Helpers
import { isEmpty } from '../../utils/object';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

// Components
import AddressHelper from '../OrderDetails/Helper/AddressHelper';
import DesktopPaymentMethod from './DesktopBillingDetail/DesktopPaymentMethod';
import OrderSummaryHelper from '../OrderDetails/Helper/OrderSummaryHelper';

const DesktopBillingDetail = ({ ROSSOrder }) => {
    const featureFlags = useSelector(getFeatureFlags);
    const [hideBillingDetails, setHideBillingDetails] = useState(false);

    const ROSSBillingDetail = ROSSOrder?.orders?.[0]?.billingProfile;
    const isKlarnaLabelEnabled = featureFlags['is-klarna-label-enabled'];

    useEffect(() => {
        /* FPT orders in DH */
        //
        // When in CONFIRMED state,
        // the “Delivery Details” section should be collapsed. (FPT DH ONLY)
        // the “Product Details” section should be expanded
        // the “Billing Details” section should be expanded
        //
        // When in IN-TRANSIT state,
        // the “Delivery Details” section should be expanded
        // the “Product Details” section should be collapsed
        // the “Billing Details” section should be collapsed
        //
        // When in DELIVERED state,
        // the “Delivery Details” section should be expanded
        // the “Product Details” section should be expanded
        // the “Billing Details” section should be expanded
        //
        const deliveryStatus = ROSSOrder?.orders?.[0]?.deliveryStatus;
        const type = ROSSOrder?.orders?.[0]?.type;
        if (type === 'FPT' && deliveryStatus === 'W') {
            setHideBillingDetails(false);
        }
        if (type === 'FPT' && deliveryStatus === 'I') {
            setHideBillingDetails(true);
        }
        if (type === 'FPT' && deliveryStatus === 'D') {
            setHideBillingDetails(false);
        }
    }, []);

    const toggleBillingView = () => {
        if (hideBillingDetails) {
            setHideBillingDetails(false);
        } else {
            setHideBillingDetails(true);
        }
    };

    if (isEmpty(ROSSOrder)) return null;

    if (isEmpty(ROSSBillingDetail)) return null;

    return (
        <Card className="margin-top delivery-info">
            <div
                className="toggle-product-button dark-border gray-bg"
                onKeyDown={() => { }}
                role="button"
                tabIndex={-1}
                onClick={() => toggleBillingView()}
            >
                <span>{`${hideBillingDetails ? 'Expand' : 'Collapse'} Billing Details`}</span>
                <img alt="collapse" src={hideBillingDetails ? 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt8434534d6387623f/5fe39f2e396e65084a9e7118/down-arrow.svg' : 'https://images.contentstack.io/v3/assets/blt95e0138311135214/blt683a6cec1ac5e736/5fe39f45e7fdff751b793746/up-arrow.svg'} />
            </div>

            <CardContent className={`padding-10 ${hideBillingDetails ? 'hidden' : ''}`}>
                <Grid container>
                    <Grid item xs={4}>
                        <h2 className="gray-color">Billing Address</h2>
                        <div className="margin-bottom">
                            <div className="">
                                {ROSSBillingDetail?.firstName} {ROSSBillingDetail?.lastName}
                            </div>
                            {ROSSBillingDetail?.businessName ? <div>{ROSSBillingDetail?.businessName}</div> : ''}
                            <AddressHelper address={ROSSBillingDetail?.addressDetail} phone={ROSSBillingDetail?.phones?.phone} />
                            <div>{ROSSBillingDetail?.emailAddress}</div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="payment-method-container">
                        <div>
                            {featureFlags['is-payment-method-showing-in-orders']
                           && (ROSSBillingDetail?.cardNumber || ROSSBillingDetail?.cardType || ROSSBillingDetail?.thirdPartyType || ROSSBillingDetail?.giftCardPayments || ROSSBillingDetail?.paymentMethod) && (
                           <DesktopPaymentMethod
                                    data={{
                                        cardNumber: ROSSBillingDetail?.cardNumber,
                                        cardType: ROSSBillingDetail?.cardType,
                                        thirdPartyType: ROSSBillingDetail?.thirdPartyType,
                                        giftCardPayments: ROSSBillingDetail?.giftCardPaymets,
                                        paymentMethod: ROSSBillingDetail?.paymentMethod,
                                        promotionCode: ROSSBillingDetail.promotionCode,
                                    }}
                                    isKlarnaLabelEnabled={isKlarnaLabelEnabled}
                                />
                            )}
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <h2 className="gray-color">Order Payment Summary</h2>
                        <OrderSummaryHelper
                            ROSSOrder={ROSSOrder}
                            featureFlags={featureFlags}
                            giftCardPayments={ROSSBillingDetail?.giftCardPaymets}
                            deviceType="desktop"
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

DesktopBillingDetail.defaultProps = {
   ROSSOrder: {},
};

DesktopBillingDetail.propTypes = {
    ROSSOrder: shape({
        orders: arrayOf(shape({
            type: string,
            deliveryStatus: string,
            billingProfile: object,
        })),
    }),
};

export default withRouter(DesktopBillingDetail);
